import script from "./addOrEditIptv.vue?vue&type=script&lang=ts&setup=true"
export * from "./addOrEditIptv.vue?vue&type=script&lang=ts&setup=true"

import "./addOrEditIptv.vue?vue&type=style&index=0&id=46207a82&lang=less"
import "./addOrEditIptv.vue?vue&type=style&index=1&id=46207a82&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46207a82"]])

export default __exports__